export type StoreType = "card" | "bank" | "tax" | "extra";
export type MenuType =
  | "card"
  | "bank"
  | "tax-buy"
  | "tax-sales"
  | "extra-buy"
  | "extra-sales";
export type TaxSubType = "SALES" | "BUY";
export type SubType = TaxSubType;
export const STORE_TYPES: StoreType[] = ["card", "bank", "tax", "extra"];
export const MENU_TYPES: MenuType[] = [
  "bank",
  "card",
  "tax-buy",
  "tax-sales",
  "extra-buy",
  "extra-sales",
];
export const STORE_TYPE_LABELS: Record<StoreType, string> = {
  card: "카드",
  bank: "통장",
  tax: "세금",
  extra: "기타",
};
export const MENU_TYPE_LABELS: Record<MenuType, string> = {
  card: "카드",
  bank: "통장",
  "tax-buy": "매입세금",
  "tax-sales": "매출세금",
  "extra-buy": "기타매입",
  "extra-sales": "기타매출",
};
export const STORE_SUB_TYPES: Record<StoreType, string[]> = {
  card: [],
  bank: [],
  tax: ["SALES", "BUY"],
  extra: ["SALES", "BUY"],
};

export const SUB_TYPE_PARAM_KEYS: Partial<Record<StoreType, string>> = {
  tax: "invoiceType",
};

export type ReportType = "submit" | "sync";

export interface Business {
  id: string;
  regNumber: string;
  name: string;
  cluster?: string;
  subCluster?: string;
  incharge: string;
  completedDataNumber: number; // 회계처리 완료된 데이터 수
  newzenTransferredDataNumber: number; // 세무사랑 전송된 데이터 수
  totalDataNumber: number;
  isAccountingConfirmed: boolean;
}

export interface SeteukBusiness {
  organizationId?: string;
  id?: string;
  productId?: string;
  regNumber?: string;
  name?: string;
  address?: string;
  zipcode?: string;
  tel?: string;
  cluster?: string;
  subCluster?: string;
  ceoName?: string;
  ceoCitizenNumber?: string;
  ceoMobileNo?: string;
  ceoEmail?: string;
  corporationNumber?: string;
  corpEstDate?: string;
  settleMonth?: string;
  salaryMonth?: "THIS_MONTH" | "NEXT_MONTH";
  salaryDay?: number;
  isPrivate?: boolean | undefined;
  isSimplifiedTaxBusiness?: boolean | undefined;
  isVatFreeTaxBusiness?: boolean | undefined;
  // certificates?: Certificate[]
  // scrapResources?: ScrapResource[]
  scrappingList?: Map<string, boolean>;
  billMethodId?: string;
  taxEmail?: string;
  hasFailedBillPayment?: boolean;
}

export interface BusinessWithCardBuyList extends Business {
  cardBuyList: CardBuy[];
}

export interface CardBuy {
  accountCode: string;
  aprvDt: string;
  bcNm: string;
  bmanClNm: string;
  busnCrdCardNoEncCntn: string;
  crcmClNm: string;
  ddcYnNm: string;
  id: string;
  isAccountingConfirmed: boolean | null;
  isVatDeduction: boolean;
  lastModifiedDate: string | null;
  mrntTxprNm: string;
  splCft: number;
  tfbCd: string;
  tfbNm: string;
  tip: number;
  totaTrsAmt: number;
  vaTxamt: number;
  vatDdcClNm: string | null;
  accSplCft?: number;
  accVaTxamt?: number;
  memo?: string; // 사용자 메모 추가
  newzenSlipKeyNo?: string | null; // 세무사랑 전송 키
  uploadDateTime?: string | null; // 세무사랑 전송일시
  aiReasoning?: string; // AI 회계처리 추천 사유
}

export interface MultiAccountCodeAmount {
  accountCode: string;
  amount: number;
}

export interface UpdateTxData {
  id: string;
  accountCode?: string;
  isVatDeduction?: boolean;
  multiAccountCodes?: MultiAccountCodeAmount[];
}

// seteuk-aitax의 Account와 유사
export interface Store {
  id: string;
  name: string;
  regNumber: string;
  address?: string; // 거래처 주소
  ceoName?: string;
  email?: string;
  cluster: string; // 거래처 업태
  subCluster: string; // 거래처 업종
  type: typeAccountType;
}

export type typeAccountType =
  | "CORPORATE"
  | "INDIVIDUAL"
  | "BANK_ACCOUNT"
  | "BIZ_CARD"
  | "PAYEE"; // 법인사업자, 개인사업자 (일반과세자), 은행 계좌, 사업용 신용카드, 급여 지급대상자
